import styled from 'styled-components';
import { PRIMARY } from '../../utils/colors';

export const SectionTitle = styled.h2`
  font-family: 'FigtreeBold', sans-serif;
  font-size: 2rem;
  color: ${PRIMARY};
  margin-bottom: 0.5rem;
`;

export const SectionSubtitle = styled.p`
  font-family: 'Figtree', sans-serif;
  font-size: 1rem;
  color: #475569;
  max-width: 700px;
  margin: 0 auto;
`;

export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  padding: 0 20px;
  font-family: 'Figtree', sans-serif;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const FeatureCard = styled.div`
  background-color: #f9fafb;
  border-radius: 1rem;
  padding: 1.5rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.3s ease;
  text-align: left;

  &:hover {
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }
`;

export const IconCircle = styled.div`
  background-color: #e2e8f0;
  border-radius: 9999px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
`;

export const FeatureTitle = styled.h4`
  font-family: 'FigtreeBold', sans-serif;
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  color: #0f172a;
`;

export const FeatureDescription = styled.p`
  font-size: 0.95rem;
  color: #334155;
  line-height: 1.5;
`;
